// extracted by mini-css-extract-plugin
export var cdUpsellAtc = "upsell-module--cd-upsell-atc--56ee1";
export var cdUpsellCard = "upsell-module--cd-upsell-card--2d079";
export var cdUpsellCardContent = "upsell-module--cd-upsell-card-content--1427c";
export var cdUpsellCardImg = "upsell-module--cd-upsell-card-img--6438e";
export var cdUpsellCardPrice = "upsell-module--cd-upsell-card-price--a6801";
export var cdUpsellHeading = "upsell-module--cd-upsell-heading--b21fe";
export var cdUpsellSwiper = "upsell-module--cd-upsell-swiper--4bcfd";
export var cdUpsellWrapper = "upsell-module--cd-upsell-wrapper--f8087";